import React, { VFC } from 'react';
import styled from '@tanium/react-emotion';
import { Pill } from '@tanium/react-pill';
import { css } from '@tanium/style-system';
import { ThemeSpace } from '@tanium/theme-data';
import { UseAdvancedFiltersReturnValue } from '../hooks/useAdvancedFiltersValues';

type PillsProps = Pick<UseAdvancedFiltersReturnValue, 'pills' | 'value' | 'updateFilter'>;

const PillsContainer = styled('div')(
  css({
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    flexWrap: 'wrap',
  }),
);

const PillWrapper = styled('div')(
  css({
    p: ThemeSpace.minor[1],
    pl: 0,
  }),
);

export const FilterPills: VFC<PillsProps> = React.memo(({ pills, value, updateFilter }) => (
  <PillsContainer>
    {pills.map((dataKey) => {
      const field = value[dataKey];
      const { label, displayValue } = field.pill;
      return (
        <PillWrapper key={dataKey}>
          <Pill
            keyForValue={field.pill.label}
            // eslint-disable-next-line react-perf/jsx-no-new-function-as-prop -- function depends on variable declared inside loop
            onRemove={() => {
              updateFilter({ dataKey, label, displayValue, value: undefined });
            }}
          >
            {field.pill.displayValue}
          </Pill>
        </PillWrapper>
      );
    })}
  </PillsContainer>
));
